import { Entity, Field } from "typegraph";

import Tag from "./Tag";

@Entity({one: "", many: "userTagsOwn"})
export default class UserTagSet {

	@Field()
	public id: string;

	@Field()
	public sortIndex: number;

	@Field({entity: Tag})
	public tag: Tag;

}



// WEBPACK FOOTER //
// ./src/panels/recommended/entities/UserTag.ts